module.exports = __webpack_public_path__ + "img/elSotano.b542481f.png";